import {
  isApprovedStatus,
  isCommitteeStatus,
  isFinalApplicationStatus,
  isFinishedStatus,
  isInstrumentationStatus,
  isPendingStatus,
  isReadyToInstrumentStatus,
  isRejectedStatus,
  isRevisionStatus,
  resolveApplicationStatusEntry,
} from '../utils/applicationStatusUtils';

export interface IStatusProps {
  applicationStatus: number | string;
}

const useStatus = ({ applicationStatus }: IStatusProps) => {
  const isApproved = isApprovedStatus(applicationStatus);
  const isRejected = isRejectedStatus(applicationStatus);
  const isInCommittee = isCommitteeStatus(applicationStatus);
  const isPending = isPendingStatus(applicationStatus);
  const isInRevision = isRevisionStatus(applicationStatus);
  const isInInstrumentation = isInstrumentationStatus(applicationStatus);
  const isReadyToInstrument = isReadyToInstrumentStatus(applicationStatus);
  const isFinished = isFinishedStatus(applicationStatus);

  const resolved = resolveApplicationStatusEntry(applicationStatus);
  const isStatusNaN =
    !resolved &&
    (applicationStatus === '' ||
      applicationStatus === null ||
      applicationStatus === undefined ||
      (typeof applicationStatus === 'number' && Number.isNaN(applicationStatus)));

  const isFinalStatus = isFinalApplicationStatus(applicationStatus);

  return {
    isApproved,
    isRejected,
    isInCommittee,
    isPending,
    isInRevision,
    isFinalStatus,
    isInInstrumentation,
    isReadyToInstrument,
    isFinished,
    isStatusNaN,
  };
};

export default useStatus;
